import { Base, withMountWhenInView } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Fade extends withMountWhenInView(Base, { threshold: [0, 1] }) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Fade',
    options: {
      delay: {
        type: Number,
        default: 0.2,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.launchAnimation();
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    const delay =
      this.$options.delay === 0.2 ? this.$options.delay : Number(this.$options.delay) / 8;
    this.$el.style.transitionDelay = `${delay}s`;

    if (this.$el.classList.contains('inview')) {
      return;
    }

    this.$el.classList.add('inview');
  }
}
